import L from 'leaflet';
import React, { useMemo } from 'react';
import { DefaultTheme, useTheme } from 'styled-components';
import { Marker } from 'react-leaflet';
import { shallowEqual, useSelector } from 'react-redux';

import { AppState } from '../../../store/interfaces';
import { AnotherDriver } from '../../../types/anotherDriver';

export const DriversAround: React.FC = React.memo(function () {
  const theme: DefaultTheme = useTheme();
  const { showDrivers, markers } = useSelector(
    (app: AppState) => ({
      showDrivers: app.map.layers.drivers,
      markers: app.map.markers.list,
    }),
    shallowEqual
  );

  const drivers = useMemo(() => {
    const driversMap: {
      [key: string]: AnotherDriver;
    } = {};

    markers.forEach((marker) => {
      marker.drivers.forEach((driver) => {
        const index = `${driver.lat}-${driver.lng}`;
        driversMap[index] = driver;
      });
    });

    return Object.values(driversMap);
  }, [markers]);

  if (!showDrivers) {
    return null;
  }

  if (drivers.length === 0) {
    return null;
  }

  const myIcon = L.icon({
    iconUrl:
      theme.name === 'light'
        ? '/assets/map/another_driver_black.svg'
        : '/assets/map/another_driver_white.svg',
    iconSize: [19, 24],
  });

  return (
    <>
      {drivers.map((coords) => (
        <Marker key={`${coords.lat}-${coords.lng}`} icon={myIcon} position={coords} />
      ))}
    </>
  );
});
